import { useLayoutEffect } from 'react';
import { holdKeyboardForDialog } from '@/hooks/useDialogFocusTrap';

/**
 * KD-16a, the keyboard rises: the Suspense fallback of a dialog loaded on demand that holds a typing
 * field. When the dialog's code is not loaded yet at the tap, this mounts in the tap's own render
 * instead of the dialog and holds the keyboard there, inside the gesture; the dialog's trap hands it
 * on to the field once both have arrived. A loaded dialog mounts in the tap itself, and its trap
 * holds the keyboard as it opens.
 */
export function KeyboardHoldFallback(): null {
  useLayoutEffect(() => {
    holdKeyboardForDialog();
  }, []);
  return null;
}
